/**
 * Main page implementation.
 */

'use strict';

/* eslint no-lonely-if: 0 */
var virtualInput = PLATFORM === 'TIZEN' || VIRTUAL,

    Input = virtualInput ? require('../modules/input') : require('../modules/spa-component-input'),

    Page      = require('stb-component-page'),
    Grid      = require('stb-component-grid'),
    ScrollBar = require('stb-component-scrollbar'),
    Button    = require('stb-component-button'),

    RadioList = require('mag-component-radio-list'),
    Modal     = require('mag-component-modal'),

    keys = require('stb-keys'),

    lang = require('../modules/lang'),

    qwertyProvider  = require('../modules/keyboards/qwerty'),
    numericProvider = require('../modules/keyboards/numeric'),
    symbolsProvider = require('../modules/keyboards/symbols'),

    actions = require('../modules/keyboards/actions'),

    page  = new Page({$node: window.pageMain}),
    input = new Input({$node: window.pageMainInput}),

    lastInputCaretPosition = 0,

    lastIntent = null,

    verticalNavigation = {
        active: 0,
        list: []
    },
    /**
     * Keyboard grid
     * @type Grid
     */
    keyboard,

    /**
     * Popup with languages radio list
     * @type Modal
     */
    popup = new Modal({
        parent: page,
        visible: false,
        title: gettext('Choose language')
    }),

    /**
     * Scrollbar for languages radio list.
     */
    scrollBar = new ScrollBar({
        value: 0,
        viewSize: 5,
        type: ScrollBar.prototype.TYPE_VERTICAL
    }),

    /**
     * Languages radio list
     */
    radioList = new RadioList({
        parent: popup,
        scroll: scrollBar,
        cycle: true,
        focusIndex: lang.active,
        size: lang.fullNames.length > 5 ? 5 : lang.fullNames.length,
        events: {
            'click:item': function ( event ) {
                lang.active = event.$item.value;
                qwertyProvider.get(null, function ( error, data ) {
                    var xIndex, yIndex;

                    if ( !error ) {
                        xIndex = keyboard.focusX;
                        yIndex = keyboard.focusY;

                        keyboard.init({
                            data: data
                        });
                        keyboard.focusItem(keyboard.map[yIndex][xIndex]);
                        popup.hide();
                        keyboard.focus();
                    }
                });
                //var v = ;
                //actualSorting = v === 1 ? 'NAME' : v === 2 ? 'DATE' : v === 3 ? 'TYPE' : 'SIZE';
                //
                //reRenderList(mainPanelList, contentSort(actualSorting), 7, 7, listScroll, {focusIndex: 0});
                //
                //menuSortingItem.innerText = evt.$item.data.title;
                //page.modals.modalMessageSort.hide();
                //mainPanelSet.focus();
                //leftPanelMenu.focus();
            },
            focus: function () {
                popup.show();
                input.$node.blur();
            },
            keydown: function ( event ) {
                switch ( event.code ) {
                    case keys.up:
                    case keys.down:
                    case keys.right:
                    case keys.left:
                    case keys.pageUp:
                    case keys.pageDown:
                    case keys.end:
                        // cursor move only on arrow keys
                        this.move(event.code);
                        break;
                    case keys.enter:
                        setTimeout(function () {
                            input.$node.focus();
                        }, 0);
                        // there are some listeners
                        if ( this.events['click:item'] && this.$focusItem ) {
                            // notify listeners
                            this.emit('click:item', {$item: this.$focusItem, event: event});
                        }
                        break;

                    case keys.back:
                    case keys.home:
                        setTimeout(function () {
                            input.$node.focus();
                        }, 0);
                        event.stop = true;
                        popup.hide();
                        keyboard.focus();
                        break;
                }
            }
        },
        data: lang.fullNames.map(function ( item, index ) {
            return {
                state: lang.active === index,
                title: item + ' (' + lang.shortNames[index] + ')',
                value: index
            };
        })
    }),

    /**
     * Show/hide password text
     */
    button = new Button({
        $node: window.pageMainButton,
        visible: false,
        value: 'Show password',
        events: {
            keydown: function ( event ) {
                switch ( event.code ) {
                    case keys.ok:
                        this.emit('click');
                        break;

                    case keys.up:
                        if ( !virtualInput ) {
                            lastInputCaretPosition = input.getCaretPosition();
                        }
                        ++verticalNavigation.active;
                        verticalNavigation.list[verticalNavigation.active].focus();
                        break;

                    case keys.down:
                        if ( !virtualInput ) {
                            lastInputCaretPosition = input.getCaretPosition();
                        }
                        --verticalNavigation.active;
                        verticalNavigation.list[verticalNavigation.active].focus();
                        break;
                }
            },
            click: function () {
                if ( virtualInput ) {
                    if ( input.type === Input.prototype.TYPE_PASSWORD ) {
                        input.init({
                            value: input.value,
                            type: Input.prototype.TYPE_TEXT
                        });
                        this.$text.innerText = gettext('Hide password');
                    } else {
                        input.init({
                            value: input.value,
                            type: Input.prototype.TYPE_PASSWORD
                        });
                        this.$text.innerText = gettext('Show password');
                    }
                } else {
                    if ( input.$node.type === 'password' ) {
                        input.$node.type = '';
                        this.$text.innerText = gettext('Hide password');
                    } else {
                        input.$node.type = 'password';
                        this.$text.innerText = gettext('Show password');
                    }
                }
            }
        }
    });


function done () {
    window.core.call('hide');
    window.core.call('blur');
    if ( virtualInput ) {
        lastIntent.emit('done', {value: input.value});
        input.setValue('');
    } else {
        lastIntent.emit('done', {value: input.$node.value});
        input.$node.value = '';
    }
    lastIntent.close();
}


popup.$body.appendChild(scrollBar.$node);


qwertyProvider.get(null, function ( badSituatuion, data ) {
    keyboard = new Grid({
        parent: page,
        $node: window.pageMainKeyboard,
        data: data,
        cycleX: true,
        cycleY: false,
        render: function ( $item, data ) {
            if ( typeof data.value === 'undefined' ) {
                $item.innerText = '';
            } else {
                $item.innerText = data.value;
            }

            if ( typeof data.className === 'undefined' ) {
                if ( $item.className.indexOf('focus') === -1 ) {
                    $item.className = 'item';
                } else {
                    $item.className = 'item focus';
                }
            } else {
                $item.className += ' ' + data.className;
            }
        },
        events: {
            focus: function () {
                if ( !virtualInput ) {
                    if ( input.$node.value.length > 0 ) {
                        input.$node.focus();
                        setTimeout(function () {
                            input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
                        }, 0);
                    } else {
                        document.body.focus();
                    }
                }
            },
            overflow: function ( event ) {
                if ( event.direction === keys.up ) {
                    lastInputCaretPosition = input.getCaretPosition();
                    ++verticalNavigation.active;
                    verticalNavigation.list[verticalNavigation.active].focus();
                }
            },
            'click:item': function ( event ) {
                if ( typeof event.$item.data.action !== 'undefined' ) {
                    switch ( event.$item.data.action ) {
                        case actions.numericKeyboard:
                            numericProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.add('small');
                                    if ( virtualInput ) {
                                        input.changeView('small', 'add');
                                    } else {
                                        input.$node.classList.add('small');
                                    }
                                    keyboard.init({
                                        data: data
                                    });
                                }
                            });
                            break;

                        case actions.symbolsKeyboard:
                            symbolsProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.remove('small');
                                    if ( virtualInput ) {
                                        input.changeView('small', 'remove');
                                    } else {
                                        input.$node.classList.remove('small');
                                    }
                                    keyboard.init({
                                        data: data
                                    });
                                }
                            });
                            break;

                        case actions.qwertyKeyboard:
                            qwertyProvider.get(null, function ( error, data ) {
                                if ( !error ) {
                                    keyboard.$node.classList.remove('small');
                                    if ( virtualInput ) {
                                        input.changeView('small', 'remove');
                                    } else {
                                        input.$node.classList.remove('small');
                                    }
                                    keyboard.init({
                                        data: data
                                    });
                                }
                            });
                            break;

                        case actions.uppercase:
                            qwertyProvider.toggleCase();
                            //isUpper = !isUpper;
                            //if ( isUpper ) {
                            //    event.$item.classList.add('enabled');
                            //    event.$item.data.className = 'uppercase enabled'
                            //} else {
                            //    event.$item.classList.remove('enabled');
                            //    event.$item.data.className = 'uppercase';
                            //}
                            qwertyProvider.get(null, function ( error, data ) {
                                var xIndex, yIndex;

                                if ( !error ) {
                                    xIndex = keyboard.focusX;
                                    yIndex = keyboard.focusY;

                                    keyboard.init({data: data});
                                    keyboard.focusItem(keyboard.map[yIndex][xIndex]);
                                }
                            });

                            break;

                        case actions.changeLanguage:
                            radioList.focus();
                            //++lang.active;
                            //if ( lang.codes.length === lang.active ) {
                            //    lang.active = 0;
                            //}
                            //if ( PLATFORM === 'MAG' ) {
                            //    window.parent.gSTB.SetInputLang(lang.codes[lang.active]);
                            //}
                            //qwertyProvider.get(null, function ( error, data ) {
                            //    var x = keyboard.focusX,
                            //        y = keyboard.focusY;
                            //
                            //    keyboard.init({
                            //        data: data
                            //    });
                            //    keyboard.focusItem(keyboard.map[y][x]);
                            //});
                            break;

                        case actions.done:
                            done();
                            break;

                        case actions.backspace:
                            if ( PLATFORM === 'MAG' ) {
                                lastInputCaretPosition = input.getCaretPosition() - 1;
                            }
                            input.removeChar(input.getCaretPosition() - 1);
                            if ( PLATFORM === 'MAG' ) {
                                input.setCaretPosition(lastInputCaretPosition);
                            }
                            break;

                        case actions.space:
                            if ( virtualInput ) {
                                input.addChar(' ');
                            } else {
                                input.addChar(' ', input.getCaretPosition());
                                ++lastInputCaretPosition;
                                input.$node.blur();
                                input.$node.focus();
                                input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
                            }
                            break;
                        case actions.cancel:
                            lastIntent.close();
                            window.core.call('hide');
                            window.core.call('blur');
                            if ( virtualInput ) {
                                input.setValue('');
                            } else {
                                input.$node.value = '';
                            }
                            break;
                        case actions.clear:
                            input.setValue('');
                            if ( !virtualInput ) {
                                input.$node.focus();
                            }
                            break;
                        case actions.moveCaretToLeft:
                            input.setCaretPosition(input.getCaretPosition() - 1);
                            lastInputCaretPosition = input.getCaretPosition();
                            break;
                        case actions.moveCaretToRight:
                            input.setCaretPosition(input.getCaretPosition() + 1);
                            lastInputCaretPosition = input.getCaretPosition();
                            break;
                        case actions.moveCaretToStart:
                            input.setCaretPosition(0);
                            lastInputCaretPosition = input.getCaretPosition();
                            break;
                        case actions.moveCaretToEnd:
                            if ( virtualInput ) {
                                input.setCaretPosition(input.value.length);
                            } else {
                                input.setCaretPosition(input.$node.value.length);
                            }
                            lastInputCaretPosition = input.getCaretPosition();
                            break;
                    }
                } else if ( typeof event.$item.data.value !== 'undefined' ) {
                    if ( virtualInput ) {
                        input.addChar(event.$item.data.value, input.getCaretPosition());
                    } else {
                        input.addChar(event.$item.data.value, lastInputCaretPosition);
                        ++lastInputCaretPosition;
                        input.$node.blur();
                        input.$node.focus();
                        input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
                    }
                }
            }
        }
    });
});

page.addListener('show', function () {
    // keyboard.focus();

    if ( !virtualInput ) {
        setTimeout(function () {
            input.$node.blur();
        }, 0);
    }

    verticalNavigation = {
        list: [keyboard, input],
        active: 0
    };
});


/* eslint complexity: 0 */
page.addListener('keydown', function ( event, eventNative ) {
    var char = null;

    console.log('event.code: ' + event.code);
    console.log('eventNative.keyCode: ' + eventNative.keyCode);

    switch ( event.code ) {
        case keys.back:
        case keys.backspace:
            if ( virtualInput ) {
                if ( PLATFORM === 'TIZEN' && event.code === keys.back ) {
                    lastIntent.close();
                    window.core.call('hide');
                    window.core.call('blur');
                    if ( virtualInput ) {
                        input.setValue('');
                    } else {
                        input.$node.value = '';
                    }
                } else {
                    if ( input.value.length === 0 ) {
                        lastIntent.close();
                        window.core.call('hide');
                        window.core.call('blur');
                        if ( virtualInput ) {
                            input.setValue('');
                        } else {
                            input.$node.value = '';
                        }
                    } else {
                        input.removeChar(input.getCaretPosition() - 1);
                    }
                }
            } else {
                if ( input.$node.value.length === 0 ) {
                    lastIntent.close();
                    window.core.call('hide');
                    window.core.call('blur');
                    if ( virtualInput ) {
                        input.setValue('');
                    } else {
                        input.$node.value = '';
                    }
                } else if ( PLATFORM === 'TIZEN' || PLATFORM === 'WEBOS' || PLATFORM === 'SMARTTV' ) {
                    input.removeChar(input.getCaretPosition() - 1);
                }
            }
            break;

        case keys.f1:
            if ( PLATFORM === 'MAG' ) {
                lastInputCaretPosition = input.getCaretPosition() - 1;
            }
            input.removeChar(input.getCaretPosition() - 1);
            if ( PLATFORM === 'MAG' ) {
                input.setCaretPosition(lastInputCaretPosition);
            }
            if ( virtualInput ) {
                eventNative.preventDefault();
            }
            break;

        case keys.f2:
            if ( lang.currentProvider !== numericProvider ) {
                radioList.focus();
            }
            break;

        case keys.f3:
            done();
            break;

        case keys.f4:
            if ( lang.currentProvider === numericProvider ) {
                break;
            }

            if ( virtualInput ) {
                input.addChar(' ');
            } else {
                char = ' ';
            }
            break;

        case keys.digit0:
            char = '0';
            break;

        case keys.digit1:
            char = '1';
            break;

        case keys.digit2:
            char = '2';
            break;

        case keys.digit3:
            char = '3';
            break;

        case keys.digit4:
            char = '4';
            break;

        case keys.digit5:
            char = '5';
            break;

        case keys.digit6:
            char = '6';
            break;

        case keys.digit7:
            char = '7';
            break;

        case keys.digit8:
            char = '8';
            break;

        case keys.digit9:
            char = '9';
            break;

        case keys.tab:
        case keys.enter:
        case keys.escape:
        case keys.end:
        case keys.home:
        case keys.left:
        case keys.up:
        case keys.right:
        case keys.down:
        case keys.menu:
        case keys.playPause:
        case keys.play:
        case keys.pause:
        case keys.stop:
        case keys.channelNext:
        case keys.channelPrev:
            // save default handler on this keys
            break;

        case keys.pageUp:
        case keys.pageDown:
        case keys.insert:
            eventNative.preventDefault();
            // nothing output
            char = '';
            break;

        case keys.del:
            if ( virtualInput ) {
                eventNative.preventDefault();
                if ( page.activeComponent !== input ) {
                    input.removeChar(input.getCaretPosition());
                }
            }
            break;

        default:
            if ( PLATFORM === 'WEBOS' ) {
                switch ( event.code ) {
                    case 19:
                    case 1536:
                    case 1537:
                    case 461:
                    case 1007:
                    case 459:
                    case 1004:
                    case 1028:
                    case 413:
                    case 412:
                    case 415:
                    case 417:
                    case 460:
                    case 457:
                    case 1003:
                    case 1056:
                    case 403:
                    case 404:
                    case 405:
                    case 406:
                        return;
                }
            }
            if ( !PLATFORM === 'MAG' ) {
                switch ( event.code ) {
                    case 186:
                        char = ';';
                        break;

                    case 187:
                        char = '=';
                        break;

                    case 188:
                        char = ',';
                        break;

                    case 189:
                        char = '-';
                        break;

                    case 190:
                        char = '.';
                        break;

                    case 191:
                        char = '/';
                        break;

                    case 192:
                        char = '`';
                        break;

                    case 219:
                        char = '[';
                        break;

                    case 220:
                        char = '\\';
                        break;

                    case 221:
                        char = ']';
                        break;

                    case 222:
                        char = '\'';
                        break;

                    default:
                        char = String.fromCharCode(event.code);
                        if ( event.shiftKey ) {
                            char = char.toLocaleUpperCase();
                        } else {
                            char = char.toLocaleLowerCase();
                        }
                        break;
                }
            }

            if ( virtualInput ) {
                console.log(event.code);
            }
            break;
    }

    console.log('char: ' + char);

    // if char was changed
    if ( char !== null ) {
        if ( PLATFORM === 'MAG' && !VIRTUAL ) {
            if ( char !== ' ' ) {
                return;
            }
        }

        if ( virtualInput ) {
            // input.addChar(char, input.getCaretPosition());
        } else {
            input.addChar(char, lastInputCaretPosition);
            ++lastInputCaretPosition;
            input.$node.blur();
            input.$node.focus();
            input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
        }
    }
});

if ( virtualInput ) {
    window.addEventListener('keypress', function ( event ) {
        console.log('keypress ' + event.charCode);
        switch ( event.charCode ) {
            case keys.back:
            case keys.backspace:
            case keys.ok:
                break;

            // case keys.left:
            //     input.setCaretPosition(input.getCaretPosition() - 1);
            //     break;

            // case keys.right:
            //     input.setCaretPosition(input.getCaretPosition() + 1);
            //     break;

            default:
                input.addChar(String.fromCharCode(event.charCode), input.getCaretPosition());
                lastInputCaretPosition = input.getCaretPosition();
                break;
        }
    });
}


input.addListener('input', function () {
    // if ( page.activeComponent !== input ) {
    //     if ( event.value.length > 0 ) {
    //         input.$node.focus();
    //     } else {
    //         // input.$node.blur();
    //     }
    // }

    if ( !virtualInput ) {
        setTimeout(function () {
            lastInputCaretPosition = input.getCaretPosition();
        }, 0);
    }
});

input.addListener('keydown', function ( event ) {
    console.log(event.code + ' code 1');
    if ( event.code === keys.down ) {
        lastInputCaretPosition = input.getCaretPosition();
        --verticalNavigation.active;
        verticalNavigation.list[verticalNavigation.active].focus();

        // setTimeout(function () {
        //     if ( input.$node.value.length > 0 ) {
        //         input.$node.focus();
        //         input.$node.selectionStart = input.$node.selectionEnd = lastInputCaretPosition;
        //     } else {
        //         document.body.focus();
        //     }
        // }, 0);
    }
});

if ( !virtualInput ) {
    input.$node.addEventListener('keydown', function ( event ) {
        if ( page.activeComponent !== input ) {
            switch ( event.keyCode ) {
                case keys.f1:
                case keys.left:
                case keys.right:
                case keys.up:
                case keys.down:
                    event.preventDefault();
                    break;

                default:
                    break;
            }
        }
    });

    input.getCaretPosition = function () {
        console.log('getCaretPosition: ' + this.$node.selectionStart);

        return this.$node.selectionStart;
    };
}

window.core.addListener('hide', function () {
    if ( lastIntent ) {
        lastIntent.close();
    }
    window.core.call('hide');
});

window.core.addListener('intent', function ( intent, callback ) {
    var logoUrl;

    keyboard.focus();

    if ( intent.action === 'keyboard' ) {
        intent.once('close', function () {
            if ( popup.visible ) {
                popup.hide();
                keyboard.focus();
            }
        });
        lastIntent = intent;
        logoUrl = intent.runnerConfig.uris.icons.logoActive;

        if ( popup.visible ) {
            popup.hide();
            keyboard.focus();
        }

        lang.active = lang.codes.indexOf(window.core.environment.language);
        if ( lang.active === -1 ) {
            lang.active = 0;
        }
        radioList.checkIndex(lang.active);

        window.pageMainLabel.innerText = input.$node.placeholder = input.value = input.$node.value = '';
        window.pageMainIcon.style.backgroundImage = 'url(' + logoUrl + ')';
        window.pageMainLabel.innerText = intent.runnerConfig.name;
        input.$node.focus();

        switch ( intent.data.type ) {
            case 'password':
                window.pageMainHeadTitle.innerText = gettext('Enter the password');
                button.$text.innerText = gettext('Show password');
                button.show();
                verticalNavigation.list = [keyboard, button, input];
                verticalNavigation.active = 0;
                keyboard.focus();
                break;

            default:
                window.pageMainHeadTitle.innerText = gettext('Enter the data');
                button.hide();
                verticalNavigation.list = [keyboard, input];
                verticalNavigation.active = 0;
                keyboard.focus();
                break;
        }

        if ( intent.data ) {
            // prepare interface
            if ( virtualInput ) {
                switch ( intent.data.type ) {
                    case 'password':
                        input.init({
                            type: Input.prototype.TYPE_PASSWORD
                        });
                        break;

                    default:
                        input.init({
                            type: Input.prototype.TYPE_TEXT
                        });
                        break;
                }
            } else {
                switch ( intent.data.type ) {
                    case 'password':
                        input.$node.type = 'password';
                        break;

                    default:
                        input.$node.type = '';
                        break;
                }
            }

            if ( intent.data.title ) {
                window.pageMainHeadTitle.innerText = intent.data.title;
            }

            if ( intent.data.icon ) {
                window.pageMainIcon.style.backgroundImage = 'url(' + intent.data.icon + ')';
            }

            if ( intent.data.description ) {
                window.pageMainLabel.innerText = intent.data.description;
            }

            if ( intent.data.placeholder ) {
                input.$node.placeholder = intent.data.placeholder;
            }

            if ( intent.data.value ) {
                if ( virtualInput ) {
                    input.setValue(intent.data.value);
                } else {
                    input.value = input.$node.value = '' + intent.data.value;
                    lastInputCaretPosition = input.$node.selectionStart = input.$node.selectionEnd = input.value.length;
                }
            } else {
                if ( virtualInput ) {
                    input.setValue('');
                } else {
                    input.value = '';
                }
            }

            if ( intent.data.position ) {
                lastInputCaretPosition = input.$node.selectionStart = input.$node.selectionEnd = +intent.data.position;
            }

            if ( intent.data.language ) {
                if ( lang.codes.indexOf(intent.data.language) !== -1 ) {
                    lang.active = lang.codes.indexOf(intent.data.language);
                }
            }
        }

        switch ( intent.data.mode ) {
            case 'pin':
            case 'number':
                numericProvider.get(null, function ( error, data ) {
                    if ( !error ) {
                        keyboard.$node.classList.add('small');
                        if ( virtualInput ) {
                            input.changeView('small', 'add');
                        } else {
                            input.$node.classList.add('small');
                        }
                        keyboard.init({
                            data: data
                        });
                    }
                });
                break;

            default:

                qwertyProvider.get(null, function ( error, data ) {
                    if ( !error ) {
                        keyboard.$node.classList.remove('small');
                        if ( virtualInput ) {
                            input.changeView('small', 'remove');
                        } else {
                            input.$node.classList.remove('small');
                        }
                        keyboard.init({
                            data: data
                        });
                    }
                });
                break;
        }

        // show keyboard
        callback(false, {});
        document.body.style.display = 'none';

        setTimeout(function () {
            document.body.style.display = '';
            window.core.call('show');
            window.core.call('focus');
        }, 0);
    }
});

if ( !virtualInput ) {
    if ( PLATFORM === 'TIZEN' || PLATFORM === 'WEBOS' || PLATFORM === 'SMARTTV' ) {
        input.$node.setAttribute('readonly', 'true');
    }
}

window.core.plugins.keyboardLayouts.addListener('update', function ( list ) {
    var lang       = require('../modules/lang'),
        codes      = [],
        fullNames  = [],
        shortNames = [];

    if ( list && list.length > 0 ) {
        list.forEach(function ( code ) {
            var index = lang.supportedCodes.indexOf(code);

            if ( index !== -1 ) {
                codes.push(lang.supportedCodes[index]);
                fullNames.push(lang.supportedFullNames[index]);
                shortNames.push(lang.supportedShortNames[index]);
            }
        });

        lang.codes = codes;
        lang.fullNames = fullNames;
        lang.shortNames = shortNames;
    }

    lang.active = lang.codes.indexOf(core.environment.language);

    if ( lang.active === -1 ) {
        lang.active = 0;
    }

    if ( PLATFORM === 'MAG' ) {
        /* eslint new-cap: 0 */
        window.parent.gSTB.SetInputLang(lang.codes[lang.active]);
    }

    radioList.init({
        focusIndex: lang.active,
        size: lang.fullNames.length > 5 ? 5 : lang.fullNames.length,
        data: lang.fullNames.map(function ( item, index ) {
            return {
                state: lang.active === index,
                title: item + ' (' + lang.shortNames[index] + ')',
                value: index
            };
        })
    });

    qwertyProvider.get(null, function ( error, data ) {
        if ( !error ) {
            keyboard.init({data: data});
        }
    });
});


// public
module.exports = page;
